import {
    ADMIN_CSM_ROLE,
    ADMIN_ROLE,
    ADMIN_SDR_ROLE
} from "../constants/panel/common";

export const accessResourceByRole = (userRole, resourceRole) => {
    if (userRole === ADMIN_ROLE) {
        return true;
    } else if (
        (userRole === ADMIN_CSM_ROLE && resourceRole.includes("csm")) ||
        (userRole === ADMIN_SDR_ROLE && resourceRole.includes("sdr"))
    ) {
        return true;
    }

    return false;
};

export const accessRoleByID = ({ role, userId, resourceId }) => {
    if ([ADMIN_CSM_ROLE, ADMIN_ROLE, ADMIN_SDR_ROLE].includes(role)) {
        return true;
    } else if (userId === resourceId) {
        return true;
    }

    return false;
};
